import React from "react";
import { init } from "../Functional/web3client";
import "../Styles/generalUse.css";

function ConnectWallet() {
  init();

  return (
    <div className="gradient-wrap-border-connect-wallet">
      <div className="web3-connection">Connect wallet</div>
    </div>
  );
}

export default ConnectWallet;
